/**
 * Parses CMS HTML with safe external link handling and image alt fallbacks.
 */

import React from "react";
import parse, { attributesToProps, domToReact } from "html-react-parser";
import { isInternalUrl, mergeExternalLinkRel } from "./linkUtils";

const createReplaceOptions = (slug) => {
  const options = {
    replace(domNode) {
      if (domNode.type !== "tag") {
        return;
      }

      if (domNode.name === "a" && domNode.attribs?.href) {
        const href = domNode.attribs.href;

        if (!isInternalUrl(href)) {
          const props = attributesToProps({
            ...domNode.attribs,
            rel: mergeExternalLinkRel(domNode.attribs.rel),
            target: "_blank"
          });

          return (
            <a {...props}>
              {domToReact(domNode.children, options)}
            </a>
          );
        }
      }

      if (domNode.name === "table") {
        const props = attributesToProps(domNode.attribs || {});

        return (
          <div className="blog-table-scroll">
            <table {...props}>
              {domToReact(domNode.children, options)}
            </table>
          </div>
        );
      }

      if (domNode.name === "img") {
        const alt = domNode.attribs?.alt;

        if (alt?.trim()) {
          return;
        }

        return (
          <img
            {...attributesToProps({
              ...domNode.attribs,
              alt: slug ? `${slug} image` : "image"
            })}
          />
        );
      }
    }
  };

  return options;
};

export const parseHtmlContent = (htmlContent, options = {}) => {
  if (!htmlContent) {
    return "";
  }

  const { slug } = options;

  return parse(htmlContent, createReplaceOptions(slug));
};

export default parseHtmlContent;
